import { EValuationReason } from '../../repositories/price-estimator/entities/estimation_user/CreateUserEstimationRequestV2Schema';
import { saveUserEstimationService } from '../../services/priceEstimator/saveUserEstimation';
import { TThunkAction } from '../../types/redux';
import { pickOnlyMeaning } from '../../utils/pickOnlyMeaning';

export const saveUserEstimation =
  ({ pushNeed }: IParams = {}): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { houseId, roomsCount, area } = getState().filters;

    if (!area || !roomsCount || !houseId) {
      return;
    }

    try {
      await saveUserEstimationService(context, {
        isAgent: true,
        area,
        roomsCount,
        houseId,
        valuationReason: EValuationReason.Buy,
        ...pickOnlyMeaning({ pushNeed: pushNeed || undefined }),
      });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

interface IParams {
  pushNeed?: boolean;
}
